import Layout from "../../components/lib/Layout/Layout";
import Navbar from "../../components/lib/Navbar/Navbar";
import { Heading } from "../../components/lib/Text/Heading";
[
  {
    link: "https://ghostform.io/widerrufsrecht/bfit",
    label: "Widerrufsbelehrung",
  },
  { link: "https://ghostform.io/static/agb-bfit.pdf", label: "AGB's" },
];
const ImpressumPage = () => {
  return (
    <div>
      <Navbar />
      <Layout>
        <main className="mt-12 text-gray-700">
          <article className="page">
            <div className="page_wrapper u-cw">
              <div className="text-center">
                <Heading level={2}>Widerrufsrecht</Heading>
              </div>
              <div className="page_content text mt-16">
                <p className="mb-4">
                  Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von
                  Gründen diesen Vertrag zu widerrufen.
                </p>
                <p className="mb-4">
                  Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
                  Vertragsabschlusses.
                </p>
                <p className="mb-4">
                  Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (active
                  Sportstudio Inh. Markus Himmes, Sarresdorfer Str. 87a, 54568
                  Gerolstein, 06591/985485, info@active-sportstudio.de) mittels
                  einer eindeutigen Erklärung (z.B. ein mit der Post versandter
                  Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen
                  Vertrag zu widerrufen, informieren. Sie können dafür das
                  beigefügte Muster-Widerrufsformular verwenden, das jedoch
                  nicht vorgeschrieben ist.
                </p>
                <p className="mb-4">
                  Sie können das Muster-Widerrufsformular oder eine andere
                  eindeutige Erklärung auch auf unserer Webseite
                  https://active-sportstudio.de elektronisch ausfüllen und
                  übermitteln. Machen Sie von dieser Möglichkeit Gebrauch, so
                  werden wir Ihnen unverzüglich (z.B. per E-Mail) eine
                  Bestätigung über den Eingang eines solchen Widerrufs
                  übermitteln.
                </p>
                <p className="mb-4">
                  Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die
                  Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf
                  der Widerrufsfrist absenden.
                </p>
                <Heading level={4} className="mt-8 mb-8">
                  Folgen des Widerrufs
                </Heading>
                <p className="mb-4">
                  Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle
                  Zahlungen, die wir von Ihnen erhalten haben, einschließlich
                  der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die
                  sich daraus ergeben, dass Sie eine andere Art der Lieferung
                  als die von uns angebotene, günstigste Standardlieferung
                  gewählt haben), unverzüglich und spätestens binnen vierzehn
                  Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
                  Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für
                  diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das
                  Sie bei der ursprünglichen Transaktion eingesetzt haben, es
                  sei denn mit Ihnen wurde ausdrücklich etwas anderes
                  vereinbart; in keinem Fall werden Ihnen wegen dieser
                  Rückzahlung Entgelte berechnet.
                </p>
                <p className="mb-4">
                  Haben Sie verlangt, dass die Dienstleistungen während der
                  Widerrufsfrist beginnen sollen, so haben Sie uns einen
                  angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem
                  Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts
                  hinsichtlich dieses Vertrages unterrichten, bereits erbrachten
                  Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag
                  vorgesehenen Dienstleistungen entspricht.
                </p>
                <Heading level={4} className="mt-8 mb-8">
                  Muster-Widerrufsformular
                </Heading>
                <p className="mb-4">
                  {" "}
                  (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte
                  dieses Formular aus und senden Sie es zurück.)
                </p>
                <p className="mb-4">
                  – active Sportstudio Inh. Markus Himmes, Sarresdorfer Str.
                  87a, 54568 Gerolstein, 06591/985485,
                  info@active-sportstudio.de
                </p>
                <p className="mb-4">
                  – Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*)
                  abgeschlossenen Vertrag über den Kauf der folgenden
                </p>
                Waren (*)/die Erbringung der folgenden Dienstleistung (*)
                <p className="mb-4">– Bestellt am (*)/erhalten am (*)</p>
                <p className="mb-4">– Name des/der Verbraucher(s)</p>
                <p className="mb-4">– Anschrift des/der Verbraucher(s)</p>
                <p className="mb-4">
                  – Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf
                  Papier)
                </p>
                <p className="mb-4">– Datum</p>
                <p className="mb-4">(*) Unzutreffendes streichen.</p>
              </div>
            </div>
          </article>
        </main>
      </Layout>
    </div>
  );
};

export default ImpressumPage;
